$(document).ready(function() {
   $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        arrows: false,
        fade: true,
     adaptiveHeight: true,
     dots: true,
        asNavFor: '.slider-nav'
    })
     .on('afterChange', function( e, slick, currentSlide ) {
        $(this).find('.deferred-media__poster').trigger('click');        
    });
    $('.slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        speed: 500,
        asNavFor: '.slider-for',
        dots: false,
      arrows: false,
        centerMode: false,
        focusOnSelect: true,
        slide: 'div'
    });

 
/*
 $('.rc_block__type').on('click', function () {
var rcprice = $(this).find('.rc_price').html();    
   $('.product-form__submit span i').html(rcprice);
  });*/

   

  });
/*
  document.addEventListener('DOMContentLoaded', () => {
  const videoElement = document.querySelector('#myVideo');
  const playPauseButton = document.querySelector('.video-control');

  if (!videoElement || !playPauseButton) return;

  playPauseButton.addEventListener('click', () => {
    playPauseButton.classList.toggle('playing');

    if (videoElement.paused) {
      videoElement.play();
    } else {
      videoElement.pause();
    }
  });

  videoElement.addEventListener('ended', () => {
    playPauseButton.classList.remove('playing');
  });
});*/

  setTimeout(function() {
$('.rc-radio__label').on('click', function () {
     var rcprice = $(this).find('.rc-radio__price').html();        
     $('.product-form__submit span i').html(rcprice);
      
  });
 }, 2000);

